import { SimpleTextAPI } from '../../../api/bussched/SimpleTextAPI';

export class SimpleTextCommand {
    constructor() {
        this.simpleTextApi = new SimpleTextAPI();
    }

    getAll(successCallback, errorCallback) {
        const apiResult = this.simpleTextApi.list();
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler os dados");
            }
        });
    }

    save(data, successCallback, errorCallback) {
        if (0 >= data.text.length) {
            return;
        }

        const dataToSend = {
            id: data.id,
            text: data.text,
            rotationAngle: data.rotationAngle,
            opacity: data.opacity
        }

        let apiResult = undefined;
        if (0 === dataToSend.id) {
            apiResult = this.simpleTextApi.create(dataToSend);
        }
        else {
            apiResult = this.simpleTextApi.update(dataToSend.id, dataToSend);
        }

        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu a criar o texto");
            }
        });
    }

    delete(simpleTextId, successCallback, errorCallback) {
        const apiResult = this.simpleTextApi.delete(simpleTextId);
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                successCallback("Texto eliminado com sucesso");
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a eliminar o texto");
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/commands/SimpleTextCommand.js